module.exports = __webpack_public_path__ + "img/play.86046e31.png";